import React from "react";
import { motion } from "framer-motion";
import HomeHeader from "../homepage/home-header/home-header";
import HomeFooter from "../homepage/home-footer/home-footer";
import GeneticCounselorsHero from "./genetic-counselors-hero/genetic-counselors-hero";
import "./genetic-counselors.css";
import LazyBackground from "../Lazy/lazy-background";
import CounselingServices from "./counseling-services/counseling-services";
import LocalExpertise from "./local-expertise/local-expertise";
import MeetOurCounselors from "./meet-our-counselors/meet-our-counselors";

const GeneticCounselors = () => {
  // Scrolls to top when the page loads
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      className="genetic-counselors-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <LazyBackground
        src={`${process.env.PUBLIC_URL}/assets/background.svg`}
        alt=""
        className="home-background home-background1"
        loading="lazy"
      />
      <HomeHeader />
      <main className="genetic-counselors-page-full">
        <GeneticCounselorsHero />
        <CounselingServices />
        <LocalExpertise />
        <MeetOurCounselors />
        <HomeFooter />
        {/* You can add more sections for this page here later */}
      </main>
    </motion.div>
  );
};

export default GeneticCounselors;